import React, { memo } from 'react'
import { AuctionShipment } from 'apps/fleet-planner/types'
import {
  formatMpWeight,
  formatMpTotalMiles,
  formatMpEquipment,
} from 'apps/fleet-planner/utils/marketplaceHelpers'
import { Bullet } from 'components/atoms'

interface IEquipmentProps {
  shipment: AuctionShipment
}

export const Equipment = memo<IEquipmentProps>(({ shipment }) => {
  return (
    <>
      <p className='flex items-center'>
        <span className='body-bold pr1'>{formatMpTotalMiles(shipment)}</span>
      </p>
      <span>{formatMpEquipment(shipment)}</span>
      <Bullet />
      <span>{formatMpWeight(shipment)}</span>
    </>
  )
})
